export default "__VITE_ASSET__C4lGAf3I__"